module.exports = __webpack_public_path__ + "img/banner-home@3x.98ff5bb3.jpg";